export default "__VITE_ASSET__BQjPXvYE__"